import type { ReactNode } from 'react'
import { cn } from '../lib/cn'

export type BadgeTone = 'neutral' | 'brand' | 'success' | 'warning' | 'danger'

const toneStyles: Record<BadgeTone, string> = {
  neutral: 'bg-gray-100 text-gray-700',
  brand: 'bg-brand-100 text-brand-800',
  success: 'bg-sage-100 text-sage-800',
  warning: 'bg-amber-100 text-amber-700',
  danger: 'bg-red-100 text-red-700',
}

export function Badge({
  tone = 'neutral',
  className,
  children,
}: {
  tone?: BadgeTone
  className?: string
  children: ReactNode
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[12px] font-bold',
        toneStyles[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}

/** A dot + label, for statuses where the dot carries the meaning at a glance. */
export function StatusDot({ tone = 'neutral' }: { tone?: BadgeTone }) {
  const dotColor: Record<BadgeTone, string> = {
    neutral: 'bg-gray-400',
    brand: 'bg-brand-500',
    success: 'bg-sage-500',
    warning: 'bg-amber-500',
    danger: 'bg-red-500',
  }
  return <span className={cn('h-2 w-2 shrink-0 rounded-full', dotColor[tone])} aria-hidden />
}
